"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePaginationSkipper = exports.Table = exports.useTable = void 0;
const react_1 = __importStar(require("react"));
const react_table_1 = require("@tanstack/react-table");
const Header_1 = require("./Header/Header");
const Row_1 = require("./Row/Row");
const Footer_1 = require("./Footer/Footer");
const Button_1 = require("../Button/Button");
const react_2 = require("@chakra-ui/react");
const faArrowRotateLeft_1 = require("@fortawesome/free-solid-svg-icons/faArrowRotateLeft");
const faDownload_1 = require("@fortawesome/free-solid-svg-icons/faDownload");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const Filter_1 = require("./Filter");
const LoadingOverlay_1 = require("../LoadingOverlay/LoadingOverlay");
const filterAvailability_1 = require("./features/filterAvailability");
const DebouncedSearch_1 = require("../Input/Search/DebouncedSearch");
const index_1 = require("../../../index");
const useTable = options => (0, react_table_1.useReactTable)({ _features: [...(options._features ?? []), filterAvailability_1.FilterAvailabilityFeature], ...options });
exports.useTable = useTable;
const pageSizes = [10, 25, 50, 100];
const Table = ({ table, columnDefs, pageSizeOptions = pageSizes, onRefreshClick, onExportClick, onResetClick, isLoading, tableAppearance = 'table', showGlobalSearch = false, globalSearchOptions, headerOptions = {
    showRefreshButton: true,
    showExportButton: true,
    showResetButton: false,
    belowHeaderContent: null,
}, footerOptions = {
    hidePagination: false,
}, placeholder, ...props }) => {
    (0, react_1.useEffect)(() => {
        table.setColumnVisibility(columnDefs.reduce((accumulator, currentValue) => ({
            ...accumulator,
            [currentValue.id ?? '']: !currentValue.meta?.column?.isInvisible,
        }), {}));
    }, []);
    const filters = [
        ...(showGlobalSearch
            ? [
                react_1.default.createElement(DebouncedSearch_1.DebouncedSearch, { onChange: value => table.setGlobalFilter(value), placeholder: globalSearchOptions?.placeholder, value: table.getState().globalFilter, isDisabled: globalSearchOptions?.isDisabled, debounce: globalSearchOptions?.debounce, type: 'search', key: 'global-search' }),
            ]
            : []),
        ...columnDefs
            .map(columnDef => {
            const { filter } = columnDef.meta ?? {};
            const column = table.getColumn(columnDef.id ?? '');
            const isFilterAvailable = table.getFilterAvailability()[column?.id ?? ''] ?? true;
            return filter && column ? (react_1.default.createElement(Filter_1.Filter, { key: columnDef.id, column: column, filter: filter, isDisabled: isLoading || !isFilterAvailable })) : null;
        })
            .filter(maybeFilter => maybeFilter !== null),
    ];
    const rows = table.getRowModel().rows;
    return (react_1.default.createElement(react_2.Box, { position: 'relative', width: '100%', ...props },
        headerOptions?.showRefreshButton ||
            headerOptions.showExportButton ||
            headerOptions?.showResetButton ||
            headerOptions?.belowHeaderContent ||
            filters.length > 0 ? (react_1.default.createElement(react_2.VStack, { gap: '0px', alignItems: 'flex-start' },
            react_1.default.createElement(react_2.HStack, { alignItems: 'baseline', justifyContent: 'space-between', minHeight: '60px', width: '100%' },
                react_1.default.createElement(react_2.HStack, { gap: '16px' }, filters.length > 0 && filters.map(filter => filter)),
                react_1.default.createElement(react_2.HStack, { gap: '8px' },
                    headerOptions.showRefreshButton && (react_1.default.createElement(Button_1.Button, { intent: 'neutral', buttonAppearance: 'outline', onClick: onRefreshClick, isDisabled: isLoading },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faArrowRotateLeft_1.faArrowRotateLeft, color: '#8A8985' }))),
                    headerOptions.showResetButton && (react_1.default.createElement(Button_1.Button, { intent: 'neutral', buttonAppearance: 'ghost', onClick: onResetClick, isDisabled: isLoading }, "Reset")),
                    headerOptions.showExportButton && (react_1.default.createElement(Button_1.Button, { intent: 'neutral', buttonAppearance: 'outline', isDisabled: isLoading, onClick: () => onExportClick?.() },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faDownload_1.faDownload, color: '#8A8985' }))))),
            headerOptions.belowHeaderContent ? headerOptions.belowHeaderContent : react_1.default.createElement(react_1.default.Fragment, null))) : null,
        react_1.default.createElement("table", { width: "100%" },
            tableAppearance === 'table' && (react_1.default.createElement("thead", null, table.getHeaderGroups().map(headerGroup => (react_1.default.createElement(Header_1.HeaderRow, { key: headerGroup.id }, headerGroup.headers.map(header => {
                return (react_1.default.createElement(Header_1.Header, { sortState: header.column.getIsSorted(), key: header.id, onClick: header.column.columnDef.meta?.column?.isSortable
                        ? header.column.getToggleSortingHandler()
                        : undefined, isSortable: header.column.columnDef.meta?.column?.isSortable, isReversed: header.column.columnDef.meta?.column?.isRightAligned }, (0, react_table_1.flexRender)(header.column.columnDef.header, header.getContext())));
            })))))),
            react_1.default.createElement(react_2.Box, { as: 'tbody' }, rows.length > 0 &&
                rows.map(row => {
                    return (react_1.default.createElement(Row_1.Row, { key: row.id, disableBorders: tableAppearance === 'ghost', onClick: row.getToggleSelectedHandler() }, row.getVisibleCells().map(cell => {
                        return (react_1.default.createElement(Row_1.Data, { isReversed: cell.column.columnDef.meta?.column?.isRightAligned, width: cell.column.columnDef.meta?.column?.width, key: cell.id }, (0, react_table_1.flexRender)(cell.column.columnDef.cell, cell.getContext())));
                    })));
                }))),
        rows.length === 0 && typeof placeholder !== 'undefined' && (react_1.default.createElement(react_2.Center, { width: '100%', py: '10px' },
            react_1.default.createElement(index_1.Text.Contrast, { size: 'xs', appearance: 'low' }, placeholder))),
        footerOptions?.hidePagination && table.getPageCount() < 2 ? null : (react_1.default.createElement(Footer_1.Footer, { table: table, isDisabled: isLoading || rows.length === 0, pageSizeOptions: pageSizeOptions, footerAppearance: tableAppearance === 'table' ? 'normal' : 'minimal' })),
        react_1.default.createElement(LoadingOverlay_1.LoadingOverlay, { isLoading: isLoading ?? false })));
};
exports.Table = Table;
const usePaginationSkipper = () => {
    const shouldSkipRef = (0, react_1.useRef)(true);
    const shouldSkip = shouldSkipRef.current;
    // Wrap a function with this to skip a pagination reset temporarily
    const skip = (0, react_1.useCallback)(() => {
        shouldSkipRef.current = false;
    }, []);
    (0, react_1.useEffect)(() => {
        shouldSkipRef.current = true;
    });
    return [shouldSkip, skip];
};
exports.usePaginationSkipper = usePaginationSkipper;
